export default {
    state: {
        showSketch: false,
        showShapeData: false,
        showCloudFileDialog: false,
        showColudFileNoExistDialog: false,
        sketchType: null,
        showDialog: false, // boolean
        showMsg: false,
        floatMenuList: [
            // {
            //     id: 0,
            //     position: [500, 500],
            //     menuList: ['hylink', 'comment', 'note', 'action', 'attach'],
            //     actionsList: [],
            //     hyperlinkList: [],
            //     commentList: [],
            //     noteText: ''
            // },
        ],
        floatOptionList: [],
        activeFloatItem: -1,
        activeFloatOption: -1,
        activeHoverFloatID: -1,
        message: {
            sponsor: "",
            title: "",
            type: 0,
            time: 3,
            imgType: 0,
            content: "",
            uniqueListenr: false,
            btnType: 0,
        },
        dialogType: null,
        exportType: undefined, // ppt excel word其中一种
        showDialogMask: false,
        expandLibraryData: [], // library拓展窗口内容
        expandMaxHeight: 300,
        expandLeft: 0,
        expandTop: 0,
        expandChoiceIndex: 0, // 扩展窗口选中的index
        showExpandLibrary: false,
        actionData: [], // action弹窗数据 EDPropertySheet
        showOutputDialog: false, // 显示导出的下拉栏
        outputDialogPosition: {
            // 导出下拉栏位置
            left: 0,
            top: 0,
        },
        targetPosition: { x: 0, y: 0 },
        aiDrawBtn: "", //AI绘画弹窗点击按钮
    },
    getters: {
        showDialog: (state) => {
            return state.showDialog;
        },
        showSketch: (state) => {
            return state.showSketch;
        },
        showMsg: (state) => {
            return state.showMsg;
        },
    },
    mutations: {
        setDialogState(state, obj) {
            if (Array.isArray(obj.data)) {
                state[obj.type].splice(0, state[obj.type].length, ...obj.data);
            } else {
                state[obj.type] = obj.data;
            }
            if (obj.type === "showDialog" && obj.data === false) {
                state.showDialogMask = false;
                state.dialogType = null;
            }
            if (obj.type === "showSketch") {
                if (obj.data) {
                } else {
                    if (!state.showDialog) {
                        state.showDialogMask = false;
                    }
                }
            }
        },
        initFloatMenuList(state, obj) {
            // 设置float菜单
            state.floatMenuList = JSON.parse(JSON.stringify(obj));
        },
        addFloatMenuList(state, obj) {
            state.floatMenuList.push(obj);
        },
        updateFloatMenuList(state, obj) {
            let num = -1;
            for (let i = 0; i < state.floatMenuList.length; i++) {
                if (state.floatMenuList[i].id == obj.id) {
                    num = i;
                    break;
                }
            }
            let removeMenu = (num, name) => {
                let menu = state.floatMenuList[num].menuList;
                for (let i = 0; i < menu.length; ++i) {
                    if (menu[i] == name) {
                        menu.splice(i, 1);
                        break;
                    }
                }
            };
            if (num != -1) {
                let keys = Object.keys(obj);
                let temp = JSON.parse(JSON.stringify(state.floatMenuList[num]));
                for (let key of keys) {
                    temp[key] = obj[key];
                    if (key == "actionsList" && obj[key].length == 0) {
                        removeMenu(num, "action");
                    } else if (key == "hyperlinkList" && obj[key].length == 0) {
                        removeMenu(num, "hylink");
                    } else if (key == "commentList" && obj[key].length == 0) {
                        removeMenu(num, "comment");
                    } else if (key == "noteText" && (obj[key].length == 0 || !obj[key])) {
                        removeMenu(num, "note");
                    } else if (key == "attachList" && obj[key].length == 0) {
                        removeMenu(num, "attach");
                    }
                }
                state.floatMenuList.splice(num, 1, temp);
            }
        },
        updateFloatMenuListAllPostion(state, arr) {
            for (let i = 0; i < state.floatMenuList.length; i++) {
                for (let j = 0; j < arr.length; j++) {
                    if (state.floatMenuList[i].id == arr[j].id) {
                        state.floatMenuList[i].position = arr[j].position;
                    }
                }
            }
        },
        updateFloatMenuListOnePostion(state, obj) {
            let num = -1;
            for (let i = 0; i < state.floatMenuList.length; i++) {
                if (state.floatMenuList[i].id == obj.id) {
                    num = i;
                    break;
                }
            }
            if (num != -1) {
                let temp = state.floatMenuList[num];
                temp.position = obj.position;
            }
        },
        deleteFloatMenuList(state, obj) {
            let num = -1;
            for (let i = 0; i < state.floatMenuList.length; i++) {
                if (state.floatMenuList[i].id == obj.id) {
                    num = i;
                    break;
                }
            }
            if (num != -1) state.floatMenuList.splice(num, 1);
        },
        clearFloatMenu(state) {
            state.floatMenuList = [];
        },
        setActiveFloatMenu(state, data) {
            state.activeFloatItem = -1;
            for (let i = 0; i < state.floatMenuList.length; ++i) {
                if (data == state.floatMenuList[i].id) {
                    state.activeFloatItem = i;
                    break;
                }
            }
        },
        setActiveFloatOption(state, data) {
            state.activeFloatOption = -1;
            for (let i = 0; i < state.floatOptionList.length; ++i) {
                if (data == state.floatOptionList[i].id) {
                    state.activeFloatOption = i;
                    break;
                }
            }
        },
        setnavigationOption(state, obj) {
            state.floatOptionList = obj;
        },
    },
};
